export default __webpack_public_path__ + "static/media/bg2.1c71bc43.jpg";